import { render, staticRenderFns } from "./exports.vue?vue&type=template&id=c5ced8f6&scoped=true&"
import script from "./exports.vue?vue&type=script&lang=js&"
export * from "./exports.vue?vue&type=script&lang=js&"
import style0 from "./exports.vue?vue&type=style&index=0&id=c5ced8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ced8f6",
  null
  
)

export default component.exports